const shareState = {
  state: {
    access_token: '', // 环信用户登陆token
    expires_in: '', // 	过期时间
    menuList: [],
    completeBookList: [],
    orgDisplayName: '',
    author: '',
    genreType: 0,
    styleId: 0,
    showIconVisible: false,
    showPaneVisible: false,
    userPhoto: '', // 个人中心头像
    name: '', // 个人中心昵称
    gender: '', // 个人中心性别
    imgBase64: '',
    bookId: 0,
    elementName: 0,
    classInfo: null, // 班级信息
    imUserInfo: null, // 环信登录用户信息
    imGroupList: null, // 环信群组列表
    myClassStudents: [], // 当前班级学生列表
    msgList: [], // 聊天消息列表
    homeWorkClassId: '', // 个人作业班级ID'
    isStudentJoin: '',
    mapInfo: '',
    audioUrl: '', // 录音文件
    scrollToTop: false,
    prepareLocation: '/books/' // 在线备课页面点击的位置
  },
  setAudio(newValue) {
    this.state.audioUrl = newValue;
  },
  setMenuList(newValue) {
    this.state.menuList = newValue;
  },
  setcompleteBookList(newValue) {
    this.state.completeBookList = newValue;
  },
  setOrgDisplayName(newValue) {
    this.state.orgDisplayName = newValue;
  },
  setAuthor(newValue) {
    this.state.author = newValue;
  },
  setGenreType(newValue) {
    this.state.genreType = newValue;
  },
  setStyleId(newValue) {
    this.state.styleId = newValue;
    localStorage.setItem('styleId', this.state.styleId);
  },
  setShowIconVisible(newValue) {
    this.state.showIconVisible = newValue;
  },
  setShowPaneVisible(newValue) {
    this.state.showPaneVisible = newValue;
  },
  setUserPhoto(newValue) {
    this.state.userPhoto = newValue;
  },
  setUserName(newValue) {
    this.state.name = newValue;
  },
  setUserGender(newValue) {
    this.state.gender = newValue;
  },
  setImgBase64(newValue) {
    this.state.imgBase64 = newValue;
  },
  setImUserInfo(newValue) {
    this.state.imUserInfo = newValue;
  },
  setImGroupList(newValue) {
    this.state.imGroupList = newValue;
  },
  setMyClassStudents(newValue) {
    this.state.myClassStudents = newValue;
  },
  setClassInfo(newValue) {
    this.state.classInfo = newValue;
  },
  setMsgList(newValue, scrollTop = false) {
    if (!newValue) return false;
    if (Array.isArray(newValue)) {
      newValue.forEach((m) => {
        if (this.state.msgList.some((g) => g.id === m.id)) return;
        this.state.msgList.unshift(m);
      });
      console.log('消息保存本地1', newValue)
    } else {
      console.log('消息保存本地2', newValue)
      this.state.msgList.push(newValue);
    }
    this.state.scrollToTop = scrollTop;
  },
  setHomeWorkClassId(newValue) {
    this.state.homeWorkClassId = newValue;
  },
  setIsStudentJoin(newValue) {
    this.state.isStudentJoin = newValue;
  },
  setMapInfo(newValue) {
    this.state.mapInfo = newValue;
  },
  setPrepareLocation(prepareLocation) {
    this.state.prepareLocation = prepareLocation;
  },
};
export default shareState;
